import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useI18n } from "../../i18n/I18nContext";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useI18n();

  const token = searchParams.get("token");
  const emailFromUrl = searchParams.get("email") || "";

  const [email, setEmail] = useState(emailFromUrl);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error(t("Token de recuperação inválido."));
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/api/reset-password`, {
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });

      toast.success(t("Password redefinida com sucesso!"));

      navigate("/login");
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        t("Não foi possível redefinir a password.");

      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-8">
        <h1 className="text-2xl font-bold mb-2 text-center">
          {t("Redefinir password")}
        </h1>

        <p className="text-sm text-gray-600 text-center mb-6">
          {t("Introduz a tua nova password.")}
        </p>

        <form onSubmit={handleResetPassword} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Email")}
            </label>

            <input
              type="email"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Nova password")}
            </label>

            <input
              type="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Confirmar password")}
            </label>

            <input
              type="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              autoComplete="new-password"
              required
              minLength={8}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gray-900 text-white rounded py-2 font-semibold disabled:opacity-60"
          >
            {loading ? t("A redefinir...") : t("Redefinir password")}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          {t("Já tens conta?")}{" "}
          <button
            type="button"
            className="text-indigo-600 font-semibold hover:underline"
            onClick={() => navigate("/login")}
          >
            {t("Entrar")}
          </button>
        </div>
      </div>
    </div>
  );
}